import React from 'react'
import { slide } from 'react-burger-menu'
import { connect } from 'react-redux'
import styled from 'styled-components'
import { Button } from 'rebass'
import { Link } from 'react-router-dom'
import Modal from 'react-modal'
import { Drawer, MenuItem } from 'material-ui'

import { hideMenu, showMenu, logOut } from '../model/actions'
import { Loader } from './Loader'

const Menu = styled(slide)`
  background: white;
  display: flex;
  align-items: center;
  flex-direction: column;
`

const Container = styled.div`
  padding-top: 1em;
`

const List = styled.ul`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 0;
  padding: 1rem;
  width: 100%;
  box-sizing: border-box;
  list-style: none;
`
const ListItem = styled.li``

const ModalContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
`

const ModalTitle = styled.h2`
  font-family: sans-serif;
`

class SidebarMenu extends React.Component {
  constructor() {
    super()
    this.state = {
      submitting: false,
    }
  }
  handleMenu = ({ isOpen }) => {
    if (!isOpen) {
      this.props.hideMenu()
    }
  }
  closeAnd = action => (...args) => {
    this.props.hideMenu()
    action(...args)
  }
  requestChange = request => {
    if (request) {
      this.props.showMenu()
    } else this.props.hideMenu()
  }
  render() {
    return (
      <Drawer open={this.props.isOpen} onRequestChange={this.requestChange}>
        <MenuItem onClick={this.closeAnd(this.props.logOut)}>
          Log Out & Clear Tasks
        </MenuItem>
      </Drawer>
    )
  }
}

const mapState = state => {
  return {
    isOpen: state.view.get('showMenu'),
  }
}

const eventMap = {
  hideMenu,
  showMenu,
  logOut,
}

export default connect(mapState, eventMap)(SidebarMenu)



// WEBPACK FOOTER //
// ./src/elements/Menu.js